import * as React from "react"
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { CircleButtonCard, PageHeading } from "../ecosystem/mybswh";
import { Grid, Link, Button } from "../ecosystem";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import * as msgs from "../../constants/textConstants";
import GrantDisclaimerModal from '../proxyManagement/grantAccess/GrantDisclaimerModal';

const FamilyManagement = (props) => {

    const { screenBreakPoint, hasPharmacyLogin, hasMychartLogin, showGrantProxyAccess, enableProxyGrantPharmacy, age } = props;
    const [showGrantDisclaimerModal, setShowGrantDisclaimerModal] = React.useState(false);
    const isMobile = !(screenBreakPoint === msgs.XL_DESKTOP || screenBreakPoint === msgs.XXL_DESKTOP) ? true : false;

    const onClickFamilyManagementButton = (tileName) => {

        logUI(`MBHWeb.UI.FamilyManagement.${tileName}.Clicked`, new Date(), Tools.getURLPath());
    };

    const grantAccess = () => {
        const { hasPharmacyLogin, hasMychartLogin } = props;
        if (hasMychartLogin && hasPharmacyLogin) {
            props.history.push("/grantaccessProxy");
        }
        setShowGrantDisclaimerModal(true);
    }


    const onAgreeGrantDisclaimer = (agreed) => {
        const { hasPharmacyLogin, hasMychartLogin } = props;
        if (agreed) {
            props.history.push("/grantaccessProxy");
        }
        else {
            logUI(`MBHWeb.UI.GrantDisclaimerModal.OnClose`, new Date(), Tools.getURLPath(), { "healthrecord": hasMychartLogin, "pharmacy": hasPharmacyLogin, "agreed": false, "fromProxyDashboard": true });
        }
        setShowGrantDisclaimerModal(false);
    }

    return (
        <Grid className="body-content family-management-container">
            <div className="row family-management__body">
                <div className="col-12 maxWidth-content">
                    <div className="row">
                        <div className="col-12 col-md">
                            <PageHeading heading="Family Management" />
                        </div>
                        {!isMobile && <div className="col-12 col-md family-management__see-all-btn">
                            <Button variant="secondary"
                                onClick={() => {
                                    onClickFamilyManagementButton("SeeAllFamilyConnections");
                                    props.history.push('/proxymanagement');
                                }}
                            >See all family connections</Button>
                        </div>}
                    </div>
                    <div className="row">
                        <div className="col-12 col-xl-6 family-management__options">
                            <CircleButtonCard
                                titleStyle={{ bold: true, type: "heading-02" }}
                                to={"/proxyrequestDOB"}
                                onClick={() => { onClickFamilyManagementButton("Family Member") }}
                                title="Add a Family Member"
                                body="Request access to appointments and records."
                            />
                        </div>

                        <div className="col-12 col-xl-6 family-management__options">
                            {age > 17 && showGrantProxyAccess && ((hasPharmacyLogin && enableProxyGrantPharmacy) || hasMychartLogin) &&
                                <>
                                    <CircleButtonCard
                                        titleStyle={{ bold: true, type: "heading-02" }}
                                        onClick={() => {
                                            onClickFamilyManagementButton("Grant Access");
                                            grantAccess();
                                        }}
                                        title="Grant Access"
                                        body="Allow a family member to view your appointments and medical records."
                                    />
                                    {showGrantDisclaimerModal &&
                                        <GrantDisclaimerModal
                                            isOpen
                                            onAgreeGrantDisclaimer={onAgreeGrantDisclaimer}
                                            healthrecord={hasMychartLogin}
                                            pharmacy={hasPharmacyLogin}
                                            fromProxyLanding
                                        />
                                    }
                                </>
                            }
                        </div>
                    </div>
                </div>
            </div>
            {isMobile &&
                <div className="row family-management__see-all-btn--mobile">
                    <div className="col-12 maxWidth-content">
                        <Link
                            children="See All Family Connections"
                            to={"/proxymanagement"}
                            onClick={() => {
                                onClickFamilyManagementButton("SeeAllFamilyConnections");
                            }}
                            typographyType="body-02"
                        />
                    </div>
                </div>
            }
        </Grid>
    )
}

const mapStateToProps = (state) => {
    return {
        screenBreakPoint: state.common.screenBreakPoint,
        hasPharmacyLogin: state.memberships.isActiveFeature_Pharmacy,
        hasMychartLogin: !state.common.epicEHRDown && state.domain.hm,
        showGrantProxyAccess: state.session.serverData ? state.session.serverData.showGrantProxyAccess : false,
        enableProxyGrantPharmacy: state.session.serverData ? state.session.serverData.enableProxyGrantPharmacy : false,
        age: state.domain.age
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FamilyManagement));